module.exports = __webpack_public_path__ + "9bfc6b1869d2aa7d4559a2c4cfe035a9.png";